export default "__VITE_ASSET__RdlYiG9Q__"